import React from 'react';

import Browser from '@wetransfer/concorde-browser';

import classNames from 'classnames';

import Assets from '@app/assets';
import I18n from '@module/i18n';

const reelVideo =
  'https://backgrounds.wetransfer.net/wallpaperassets/1905/reel.mp4';
const reelLoop = Assets.lookup('quote/reel-loop.mp4');
const reelPoster = Assets.lookup('quote/reel-poster.jpg');

class Home extends React.PureComponent {
  state = {
    mainVideoPlaying: false,
    loopVideoPlaying: false,
  };

  constructor(props) {
    super(props);

    this.reelLoop = React.createRef();
    this.reelVideo = React.createRef();
  }

  handleVideoPlaying = () => {
    this.reelLoop.current.pause();
    this.setState({
      loopVideoPlaying: false,
      mainVideoPlaying: true,
    });
    this.reelLoop.current.currentTime = 0;
  };

  handleVideoEnded = () => {
    this.setState({ mainVideoPlaying: false });
  };

  handlePlayClick = () => {
    this.reelVideo.current.load();
    this.reelVideo.current.play();
  };

  handleLoopPlaying = () => {
    this.setState({ loopVideoPlaying: true });
  };

  handleLoopPaused = () => {
    this.setState({ loopVideoPlaying: false });
  };

  handleMouseEnter = () => {
    if (!Browser.supportsTouchEvents && !this.state.mainVideoPlaying) {
      this.reelLoop.current.play();
    }
  };

  handleMouseLeave = () => {
    if (!Browser.supportsTouchEvents && !this.state.mainVideoPlaying) {
      this.reelLoop.current.pause();
      this.reelLoop.current.currentTime = 0;
    }
  };

  renderGuidelinesButton() {
    return (
      <a
        className="button button__secondary advertise-stats__guidelines-shortcut"
        href="/advertise/guidelines"
      >
        {I18n.t('page.advertise.button.guidelines')}
      </a>
    );
  }

  render() {
    const reelClasses = classNames('page-advertise__reel', 'advertise-reel', {
      'advertise-reel--playing': this.state.mainVideoPlaying,
    });
    const loopVideoClasses = classNames('advertise-reel__loop', {
      'advertise-reel__loop--playing': this.state.loopVideoPlaying,
    });

    return (
      <div className="page-advertise">
        <div className="page-advertise__intro advertise-intro">
          <h1>{I18n.t('page.advertise.home.intro.title_032019')}</h1>
          <p>{I18n.t('page.advertise.home.intro.description_032019')}</p>
          <div className="advertise-intro__buttons">
            <a className="button button--enabled" href="/advertise/contact">
              {I18n.t('page.advertise.button.contact')}
            </a>
            <a className="button button__secondary" href="/advertise/gallery">
              {I18n.t('page.advertise.button.gallery')}
            </a>
          </div>
        </div>

        <div className={reelClasses}>
          <div className="advertise-reel__container">
            <video
              ref={this.reelVideo}
              className="advertise-reel__video"
              preload="metadata"
              onPlaying={this.handleVideoPlaying}
              onEnded={this.handleVideoEnded}
              src={reelVideo}
              controlsList="nodownload"
              controls
            />
            <video
              ref={this.reelLoop}
              className={loopVideoClasses}
              preload="metadata"
              src={reelLoop}
              onPlaying={this.handleLoopPlaying}
              onPause={this.handleLoopPaused}
              muted
              loop
            />
            <img className="advertise-reel__poster" src={reelPoster} alt="" />
            <div
              className="advertise-reel__cover"
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
            >
              <span className="advertise-reel__title">
                WeTransfer Advertising Showreel
              </span>
              <button
                className="advertise-reel__play"
                onClick={this.handlePlayClick}
              />
            </div>
          </div>
        </div>

        <div className="page-advertise__stats advertise-stats">
          <h2 className="advertise-stats__title">
            {I18n.t('page.advertise.home.stats.title')}
          </h2>
          <div className="advertise-stats__item stat">
            <div className="number">
              5.0
              <span>&times;</span>
            </div>
            <div className="content">
              <h4>{I18n.t('page.advertise.home.stats.ctr')}</h4>
              <p>
                {I18n.t('page.advertise.home.stats.our_number', {
                  percentage: '0.70%',
                })}
              </p>
              <p>
                {I18n.t('page.advertise.home.stats.industry', {
                  percentage: '0.14%',
                })}
              </p>
            </div>
          </div>
          <div className="advertise-stats__item stat">
            <div className="number">
              3.5
              <span>&times;</span>
            </div>
            <div className="content">
              <h4>{I18n.t('page.advertise.home.stats.engagement')}</h4>
              <p>
                {I18n.t('page.advertise.home.stats.our_number', {
                  percentage: '11.9%',
                })}
              </p>
              <p>
                {I18n.t('page.advertise.home.stats.industry', {
                  percentage: '3.36%',
                })}
              </p>
            </div>
          </div>
          <div className="advertise-stats__item stat">
            <div className="number">
              1.3
              <span>&times;</span>
            </div>
            <div className="content">
              <h4>{I18n.t('page.advertise.home.stats.view_time')}</h4>
              <p>
                {I18n.t('page.advertise.home.stats.our_time', {
                  percentage: '35.4s',
                })}
              </p>
              <p>
                {I18n.t('page.advertise.home.stats.industry', {
                  percentage: '28.2s',
                })}
              </p>
            </div>
          </div>
          <div className="advertise-stats__source">
            <p
              dangerouslySetInnerHTML={{
                __html: I18n.t('page.advertise.home.stats.source', {
                  name: 'richmediagallery.com',
                  url: 'https://www.richmediagallery.com/tools/benchmarks',
                }),
              }}
            />
          </div>
          {Browser.isMobile && this.renderGuidelinesButton()}
        </div>
      </div>
    );
  }
}

export default Home;
